function Samoa({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1998)">
  <path d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C5.49563 10.5044 10.1565 5.8435 16 0C24.8365 0 32 7.1635 32 16Z" fill="#D80027"/>
  <path d="M16 16C16 7.1635 16 6.12175 16 0C7.1635 0 0 7.1635 0 16H16Z" fill="#0052B4"/>
  <path d="M12.8159 10.4355L13.075 11.2327H13.9131L13.235 11.7253L13.4941 12.5225L12.8159 12.0298L12.1378 12.5225L12.3969 11.7253L11.7188 11.2327H12.5569L12.8159 10.4355Z" fill="#F0F0F0"/>
  <path d="M8.60621 4.17383L9.0379 5.50252H10.4349L9.30465 6.32345L9.73646 7.65208L8.60621 6.83089L7.47603 7.65208L7.90778 6.32345L6.77759 5.50252H8.17446L8.60621 4.17383Z" fill="#F0F0F0"/>
  <path d="M12.7802 5.56445L13.2119 6.8932H14.6088L13.4786 7.71414L13.9103 9.04277L12.7802 8.22158L11.65 9.04277L12.0817 7.71414L10.9515 6.8932H12.3484L12.7802 5.56445Z" fill="#F0F0F0"/>
  <path d="M9.48085 11.1309L9.9126 12.4595H11.3095L10.1793 13.2805L10.611 14.6091L9.48085 13.788L8.35066 14.6091L8.78241 13.2805L7.65222 12.4595H9.04916L9.48085 11.1309Z" fill="#F0F0F0"/>
  <path d="M5.82356 7.65234L6.25531 8.98103H7.65225L6.522 9.80197L6.95375 11.1306L5.82356 10.3095L4.69343 11.1306L5.12512 9.80197L3.995 8.98103H5.39187L5.82356 7.65234Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Samoa;
